var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-qrcode" }, [
    _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.$route.query.khxm))]),
    _vm._v(" "),
    _c("div", { staticClass: "phone" }, [
      _vm._v(_vm._s(_vm.$route.query.khdh)),
    ]),
    _vm._v(" "),
    _c("img", { staticClass: "qrcode", attrs: { src: _vm.qrcode } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }